
import {retry, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response, Headers  } from '@angular/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment'
import { AuditStdImport } from '../main/rate-audit/ra-create/utilities/auditstd-import-model'
import { MsgResult } from 'app/core';

@Injectable()
export class ExcelImportService {
private domainStr: string;

  constructor(private http: Http) {
    this.domainStr = environment.baseWebApiUrl;

   }


  importRateAvailabilityExcelFile(filename:string){
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

     //return this.http.get(this.domainStr + "api/ImportAudit/PostXLSImport/" + filename)
     return this.http.post(this.domainStr + "api/ImportAudit/PostRateAvailabilityXLSImport", JSON.stringify(filename), {headers:headers} ).pipe(//{filename:filename} )//{id:filename}, {headers:headers})
        map(response => {
          const data = response.json();
          return data;
        }));
  }

   importExcelFile(filename:string){
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

     //return this.http.get(this.domainStr + "api/ImportAudit/PostXLSImport/" + filename)
     return this.http.post(this.domainStr + "api/ImportAudit/PostXLSImport", JSON.stringify(filename), {headers:headers} ).pipe(//{filename:filename} )//{id:filename}, {headers:headers})
        map(response => {
          const data = response.json();
          return data;
        }));
  }

  importExcelRetryDelayedFile(filename: string){
    //return  this.http.get(this.domainStr + "api/ImportAudit/DelayedFile/" + filename)
    return  this.http.post(this.domainStr + "api/ImportAudit/DelayedFile", JSON.stringify(filename), {headers:new Headers({ 'Content-Type': 'application/json' })} ).pipe(
        map(  response => {
            const data = response.json();
            if (data.delayedFile) {
              //console.log("retry delayed file")
              throw({delayError:"string"});
            }
            return  data;
        }),
        retry( 10 ),);
  }

  importReverseAuditExcelFile(filename:string):Observable<MsgResult>{
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

     return this.http.post(this.domainStr + "api/ImportAudit/PostXLSImportReverseAudit", JSON.stringify(filename), {headers:headers} ).pipe(//{filename:filename} )//{id:filename}, {headers:headers})
        map(response => {
          const data = response.json();
          return data;
        }));
  }

  importReverseAuditFileRetryDelayedFile(filename: string):Observable<MsgResult>{
    //return  this.http.get(this.domainStr + "api/ImportAudit/DelayedFile/" + filename)
    return  this.http.post(this.domainStr + "api/ImportAudit/DelayedReverseAuditImport", JSON.stringify(filename), {headers:new Headers({ 'Content-Type': 'application/json' })} ).pipe(
        map(  response => {
            const data = response.json() as MsgResult;
            if (!data.success) {
              if (data.message == "delayed") {
                //console.log("retry delayed file")
                throw(data);
              }
              //fall thru to return immeadiate error
            }
            return  data;
        }),
        retry( 20 ),);
  }
}  
